/*
courtesy of Nick Robinson and the Soli team :D
 */

import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';

export const sentryActionLogger: Middleware = ({ getState }: MiddlewareAPI) => (
    next: Dispatch
) => action => {
    Sentry.addBreadcrumb({
        category: 'redux-action',
        message: action.type,
        level: Severity.Info,
    });

    return next(action);
};
